var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeroquizOops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 479,
    height: 391,
    viewBox: "0 0 479 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3580_6825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.435 264.199C363.053 261.721 360.724 260.025 358.245 260.424C355.766 260.807 354.069 263.134 354.469 265.612C355.118 269.835 355.949 283.069 351.375 288.389C350.393 289.536 349.195 290.234 347.698 290.5L348.114 265.296C348.181 261.638 345.22 258.629 341.56 258.629C337.9 258.629 334.906 261.671 335.006 265.346L336.187 313.161C334.606 312.912 333.375 312.213 332.344 311.016C327.769 305.696 328.601 292.462 329.25 288.239C329.632 285.762 327.952 283.451 325.473 283.052C322.995 282.67 320.683 284.365 320.283 286.826C319.951 288.904 317.339 307.442 325.44 316.902C328.235 320.16 331.995 322.006 336.403 322.288L336.919 343.104H346.817L347.532 299.611C351.84 299.279 355.533 297.433 358.262 294.241C366.363 284.781 363.735 266.26 363.419 264.165L363.435 264.199Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5 547.002C332.821 547.002 479 495.285 479 431.488C479 367.69 332.821 315.973 152.5 315.973C-27.821 315.973 -174 367.69 -174 431.488C-174 495.285 -27.821 547.002 152.5 547.002Z",
    fill: "url(#paint0_linear_3580_6825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.618 291.464C204.618 291.464 204.435 302.587 204.618 303.701C204.801 304.815 200.26 311.332 198.413 311.033C196.55 310.75 192.84 310.118 192.308 309.503C191.776 308.888 192.009 307.425 192.192 306.095C192.391 304.765 193.772 292.661 193.772 292.03C193.772 291.398 202.556 289.769 204.618 291.448V291.464Z",
    fill: "#FFD3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.415 303.052C195.086 304.299 193.788 308.123 193.456 308.173C193.123 308.223 192.507 308.123 192.507 307.741C192.507 307.358 192.607 306.095 192.175 306.095C191.742 306.095 191.276 308.173 191.177 311.182C191.077 314.208 190.012 321.391 191.177 322.305C191.909 322.887 198.629 326.411 198.829 326.877C199.028 327.343 198.679 330.651 199.261 331.166C199.827 331.682 201.141 332.962 202.189 333.012C203.237 333.062 209.226 333.677 212.054 333.012C214.882 332.347 218.475 330.984 218.558 330.601C218.658 330.219 217.843 322.205 216.961 321.224C216.063 320.227 209.609 311.365 209.076 310.567C208.56 309.769 208.178 307.824 208.178 306.693C208.178 305.563 207.146 303.086 205.25 302.504C203.27 301.889 199.162 302.105 197.415 303.036V303.052Z",
    fill: "url(#paint1_linear_3580_6825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.813 297.898C136.813 297.898 136.813 304.366 136.63 305.48C136.447 306.594 140.988 313.111 142.835 312.812C144.698 312.529 148.408 311.897 148.94 311.282C149.472 310.667 149.239 309.204 149.056 307.874C148.857 306.544 147.676 299.079 147.676 298.464C147.676 297.848 138.892 296.203 136.83 297.882L136.813 297.898Z",
    fill: "#FFD3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.802 155.034C140.173 164.577 135.199 197.313 135.199 213.207C135.199 229.101 133.602 269.651 133.602 275.819C133.602 281.987 132.937 297.266 134.534 298.064C136.131 298.862 139.841 301.256 144.898 300.458C149.938 299.66 151.269 296.485 151.402 293.559C151.535 290.633 152.733 269.668 153.931 261.588C155.128 253.491 159.37 237.88 162.165 227.838C164.96 217.796 171.464 197.612 173.178 197.679C174.908 197.762 185.654 241.986 186.552 244.497C187.451 247.007 189.147 282.619 189.264 285.612C189.38 288.604 189.264 291.481 191.144 292.694C193.023 293.908 198.779 296.901 201.774 297.117C204.768 297.333 206.764 292.578 207.313 291.131C207.862 289.685 208.844 242.053 208.494 228.985C208.145 215.917 209.176 191.544 208.561 183.597C207.962 175.65 206.016 158.625 204.768 155.034C203.537 151.459 142.785 155.034 142.785 155.034H142.802Z",
    fill: "#192B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.237 44.0244C126.749 41.2313 138.443 28.0471 140.772 27.5816C143.101 27.1161 148.757 26.1019 150.005 24.7885C151.269 23.4917 156.592 6.76631 154.48 3.70719C152.367 0.664701 144.216 1.52923 141.754 6.69981C139.292 11.887 139.408 14.597 135.332 18.1715C131.257 21.746 113.524 36.2436 111.86 37.7066C110.213 39.1697 113.49 46.2854 116.069 47.5157C118.664 48.746 124.203 43.9911 124.203 43.9911L124.237 44.0244Z",
    fill: "url(#paint2_linear_3580_6825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.592 48.0326C150.603 49.2795 140.672 50.3435 137.395 51.4076C134.118 52.4716 121.192 56.9938 121.292 55.0652C121.392 53.1366 127.281 44.6576 126.216 43.793C125.152 42.9285 118.78 41.8645 117.732 40.5178C116.668 39.1711 115.22 35.979 113.773 36.378C112.326 36.7604 95.5574 52.3885 96.7052 58.3571C99.4168 72.4556 139.059 82.7303 139.974 88.8651C140.872 95.0166 136.896 153.954 139.075 156.132C141.254 158.31 164.228 166.623 175.806 167.338C187.384 168.053 207.696 164.03 208.81 160.987C209.925 157.945 203.154 99.3725 203.953 99.3725C204.751 99.3725 204.951 117.81 213.784 122.582C219.606 125.724 227.608 122.482 229.155 120.753C230.686 119.024 223.682 94.5012 220.505 86.2383C217.327 77.9753 214.3 60.8842 207.13 54.8325C199.96 48.7641 189.846 49.7949 186.369 48.3817C182.892 46.9519 171.198 47.9827 168.253 47.6668C165.309 47.3509 156.642 48.0492 156.642 48.0492L156.592 48.0326Z",
    fill: "url(#paint3_linear_3580_6825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.284 109.665C231.284 109.665 220.97 112.774 220.172 113.854C219.374 114.918 217.943 119.208 220.172 121.003C222.401 122.782 224.863 124.129 227.508 122.067C230.153 120.006 232.582 117.229 234.112 116.88C235.643 116.531 240.234 117.196 242.147 116.431C244.077 115.683 247.72 101.102 246.256 100.221C244.776 99.3401 231.301 109.681 231.301 109.681L231.284 109.665Z",
    fill: "url(#paint4_linear_3580_6825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.626 46.0698C153.298 45.3882 146.877 39.1037 146.278 32.7194C145.696 26.5015 141.138 9.02792 157.058 2.47742C171.996 -3.67406 187.367 2.66031 189.58 10.2416C191.643 17.3241 174.109 17.64 167.671 22.2453C161.25 26.8506 160.801 29.9263 159.204 29.1948C157.607 28.4633 156.626 46.0698 156.626 46.0698Z",
    fill: "#F3636E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.359 33.6159C156.143 36.4589 155.428 50.2415 156.625 52.2699C157.723 54.1319 159.67 59.5519 167.305 59.3025C174.941 59.0697 179.898 51.4386 180.314 50.5408C180.73 49.643 179.832 38.6202 179.832 36.7748C179.832 34.9293 169.568 30.5734 165.459 30.6898C161.35 30.8062 156.559 30.9558 156.359 33.6325V33.6159Z",
    fill: "url(#paint5_linear_3580_6825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.074 33.6677C157.939 33.651 156.925 38.8881 158.472 40.6006C160.035 42.313 166.823 51.2576 174.009 50.3931C180.231 49.6449 179.332 44.2914 180.231 39.8857C181.046 35.8789 183.624 35.5464 184.539 25.1055C184.889 21.0654 186.802 14.7311 183.292 13.5673C179.781 12.4035 166.59 9.27787 163.313 13.5673C160.035 17.8567 159.719 28.148 158.006 26.8179C156.293 25.4879 152.699 19.0205 150.603 22.5285C148.491 26.0365 152.466 33.8173 157.074 33.6843V33.6677Z",
    fill: "#F2DAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.536 87.0701L191.626 113.488C190.545 114.868 191.543 116.88 193.289 116.847L231.933 116.198C232.582 116.198 233.181 115.882 233.563 115.367L253.309 88.982C254.241 87.7351 253.343 85.9561 251.779 85.9728L214.133 86.2887C213.501 86.2887 212.919 86.5879 212.52 87.0701H212.536Z",
    fill: "url(#paint6_linear_3580_6825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.591 97.7097C243.561 97.9092 240.6 99.0564 240.6 100.12C240.6 101.184 242.979 101.467 243.628 101.567C244.277 101.667 245.142 101.866 244.892 102.199C244.643 102.531 244.16 104.16 242.846 103.878C241.532 103.595 235.809 103.512 234.711 103.512C233.614 103.512 232.299 104.293 232.216 105.108C232.133 105.923 231.883 106.089 231.235 106.122C230.586 106.156 229.388 106.771 229.388 107.835C229.388 108.899 232.017 109.846 232.017 110.229C232.017 110.611 237.173 113.753 238.188 114.335C239.203 114.917 241.083 116.414 242.147 116.414C243.212 116.414 244.992 115.399 245.125 113.936C245.258 112.473 247.354 111.409 247.387 110.694C247.421 109.979 246.722 109.447 246.805 108.999C246.888 108.55 248.718 107.901 248.718 106.771C248.718 105.64 248.003 104.094 247.887 103.612C247.787 103.13 247.354 102.099 247.787 101.966C248.219 101.833 249.7 100.453 249.434 99.1728C249.167 97.8926 246.539 97.61 245.591 97.7097V97.7097Z",
    fill: "#FFD3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.833 304.849C146.162 306.096 147.459 309.92 147.792 309.97C148.125 310.02 148.74 309.92 148.74 309.538C148.74 309.155 148.64 307.892 149.073 307.892C149.505 307.892 149.971 309.97 150.071 312.979C150.171 316.005 151.236 323.187 150.071 324.102C149.339 324.684 142.618 328.208 142.419 328.674C142.236 329.139 142.552 332.448 141.986 332.963C141.421 333.479 140.107 334.759 139.059 334.809C138.027 334.859 132.022 335.474 129.194 334.809C126.366 334.144 122.773 332.78 122.689 332.398C122.59 332.016 123.405 324.002 124.286 323.021C125.185 322.024 131.639 313.162 132.172 312.364C132.687 311.566 133.07 309.621 133.07 308.49C133.07 307.36 134.101 304.883 135.998 304.301C137.977 303.686 142.086 303.902 143.833 304.833V304.849Z",
    fill: "url(#paint7_linear_3580_6825)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3580_6825",
    x1: 152.5,
    y1: 263.619,
    x2: 152.5,
    y2: 445.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3580_6825",
    x1: 209.808,
    y1: 315.006,
    x2: 192.914,
    y2: 327.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C38CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3580_6825",
    x1: 161.683,
    y1: 27.9806,
    x2: 129.727,
    y2: 24.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3580_6825",
    x1: 23828.7,
    y1: 5389.57,
    x2: 32440,
    y2: 11998.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C38CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3580_6825",
    x1: 233.064,
    y1: 114.42,
    x2: 234.676,
    y2: 141.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F2DAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3580_6825",
    x1: 5155.54,
    y1: 709.633,
    x2: 5354.76,
    y2: 1065.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3580_6825",
    x1: 215.331,
    y1: 88.2837,
    x2: 233.713,
    y2: 122.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB9A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3580_6825",
    x1: 5250.69,
    y1: 6241.66,
    x2: 5556.4,
    y2: 6449.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C38CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3580_6825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 653,
    height: 547,
    fill: "white",
    transform: "translate(-174)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroquizOops);
export default __webpack_public_path__ + "static/media/ZeroquizOops.8dc4dc296a43c64e761cf655b52195c6.svg";
export { ForwardRef as ReactComponent };